import React from "react";

import Layout from "../components/Layout";
import SEO from "../components/SEO";
import me from "../images/me.png";
import { Link } from "gatsby";

function AboutPage() {
  return (
    <Layout>
      <SEO title="About"
      />

      <section className="w-full px-4 sm:max-w-6xl mx-auto py-16">
        <h1 className="text-3xl leading-tight font-extrabold text-gray-900 sm:text-4xl text-center">About Me</h1>
        <img className="my-8 h-64 object-cover mx-auto rounded-full" src={me} alt="my-pic" />
        <p className="mt-6 text-gray-800 sm:text-lg md:text-xl">
          Hello! I'm Bilal. I like to build things. I've built a variety of products over my career as a builder such as 
        </p>
        <ul className="mt-6 text-indigo-600 font-semibold sm:text-lg md:text-xl">
          <li><Link to="/templates">These cool landing pages</Link></li>
          <li><a target="_blank" rel="noreferrer" href="https://scrilys.com/">Scrilys</a></li>      
          <li><a target="_blank" rel="noreferrer" href="https://pichance.com/">Pic.Hance</a></li>
          <li><a target="_blank" rel="noreferrer" href="https://corgistickers.netlify.app/">CorgiStickers</a></li>
          <li><a target="_blank" rel="noreferrer" href="https://iwanttobuildthis.com/">I Want To Build This</a></li>
          <li><a target="_blank" rel="noreferrer" href="https://9gans.com/">9 GANS</a></li>
          <li className="text-gray-800 font-normal">and more...</li>
        </ul>   
        <p className="mt-6 text-gray-800 sm:text-lg md:text-xl">
          I am at my happiest in the thick of the creation process, going from ideation to execution at blinding speed.
        </p>  
        <p className="mt-6 text-gray-800 sm:text-lg md:text-xl">
        And one of the best tech stacks I have found to enable this workflow is React + TailwindCSS. By combining the awesomeness of React 
        (or stacks like Gatsby or Next.js on top of React) with the speed and ease of use of TailwindCSS, you get an unbeatable mixture of speed and performance. 
        </p>  
        <p className="mt-6 text-gray-800 sm:text-lg md:text-xl">
          Of course there are lots of great alternatives but for me this was a natural fit as an indie dev. If you've read so far chances are you feel the same.
        </p>  
        <p className="mt-6 text-gray-800 sm:text-lg md:text-xl">
          And if you want to get a jump ahead on this process, you can get one of our landing page <Link className="text-indigo-600 font-medium" to="/templates">templates</Link> so you can focus on your product from day 1! 
        </p>  
        <p className="mt-6 text-gray-800 sm:text-lg md:text-xl">
          Need something a bit more custom? I got you. Shoot me a <Link className="text-indigo-600 font-medium" to="/contact">message</Link> and we can work out a project specifically tailored for your needs.
        </p>
        <p className="mt-6 text-gray-800 sm:text-lg md:text-xl">
          Looking forward to hearing from you. :)
        </p>                                    
        <p className="mt-6 text-gray-800 sm:text-lg md:text-xl">
          Bilal
        </p>                                                                                                
      </section>
    </Layout>
  );
}

export default AboutPage;
